<template>
  <div
    :class="[
      'flex grow flex-col gap-y-5 overflow-y-auto border-gray-200 bg-white px-6 pb-4 dark:bg-black sm:border-r',
      { 'notch-padding': Capacitor.isNativePlatform() === true }
    ]"
  >
    <div class="flex h-16 shrink-0 items-center">
      <RouterLink to="/" @click="navStore.setNavigationIsOpen(false)">
        <ImageComponent
          :alt="brand"
          :asset-info="{ name: brand, type: 'logo', extension: 'png' }"
          class="h-7 w-auto"
        />
      </RouterLink>
    </div>
    <nav class="flex flex-1 flex-col">
      <ul role="list" class="flex flex-1 flex-col gap-y-5">
        <li v-for="navItem in navStore.navigation" :key="navItem.header">
          <MenuItem :nav-item="navItem" />
        </li>
        <li v-if="appStore.isProd() === false" class="h-full w-full">
          <RouterLink
            :class="[
              'flex w-full items-center gap-x-3 rounded-md p-2 text-left text-sm font-normal leading-6 text-gray-600 hover:rounded-md hover:bg-gray-100'
            ]"
            to="/style-guide"
          >
            <font-awesome-icon
              size="lg"
              class="fatshrink-0 w-5 text-gray-400"
              aria-hidden="true"
              :icon="['fal', 'narwhal']"
            />
            Style guide
          </RouterLink>
        </li>
        <li class="mt-auto border-t-2">
          <a
            class="group -mx-2 mt-2 flex cursor-pointer gap-x-3 rounded-md p-2 pl-4 text-sm font-semibold leading-6 text-brand-500 hover:bg-gray-50"
            @click="authStore.signOut()"
          >
            <font-awesome-icon
              size="lg"
              class="fatshrink-0 w-5 text-gray-400"
              aria-hidden="true"
              :icon="['fal', 'lock-open']"
            />
            {{ $t('Logout') }}
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>
<script setup lang="ts">
import { useAppStore, useNavigationStore, useAuthStore } from '@/stores'
import { Capacitor } from '@capacitor/core'

const navStore = useNavigationStore()
const authStore = useAuthStore()
const appStore = useAppStore()
const brand = appStore.getBrand()
</script>
